<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มประกาศใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ announcementInit.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose" aria-label="ปิดฟอร์ม">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          หัวข้อ
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="announcement.title"
          :rules="[(v) => !!v || 'โปรดระบุหัวข้อ']"
          required
          clearable
          @change="checkEmpty($event, 'title')"
          outlined
          dense
          :disabled="isCreatedAnnouncement || formAction === 'edit'"
        >
        </v-text-field>
        <label class="body-2">
          ข้อความ
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-textarea
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="announcement.message"
          :rules="[(v) => !!v || 'โปรดระบุข้อความ']"
          required
          outlined
          :disabled="isCreatedAnnouncement || formAction === 'edit'"
        ></v-textarea>
        <div>
          <label class="body-2">ประกาศหมดอายุ</label>
          <date-picker
            style="width: 100%; margin-top: 4px"
            v-model="announcement.expired_datetime"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            :disabled="isCreatedAnnouncement"
          ></date-picker>
        </div>
        <div class="mt-7">
          <label class="body-2 d-block mb-1">แนบรูป</label>
          <div v-if="formAction === 'edit'">
            <div v-if="announcement.announcement_image.length === 0">
              No Images
            </div>
            <div
              v-for="file in announcement.announcement_image"
              :key="file.announcement_image_uuid"
              class="mb-4"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 5px;
                overflow: hidden;
              "
            >
              <v-img :src="file.image_url" width="100%">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </div>
          <div v-else>
            <div>
              <div
                v-for="file in selectedFiles"
                :key="file.uuid"
                class="mb-4"
                style="
                  position: relative;
                  border: 1px solid #e0e0e0;
                  border-radius: 5px;
                  overflow: hidden;
                "
              >
                <v-btn
                  @click="handleDeleteFile(file.uuid)"
                  style="
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    z-index: 9999;
                  "
                  color="error"
                  fab
                  small
                  dark
                  depressed
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-img :src="file.image_base64" width="100%"></v-img>
              </div>
            </div>
            <input
              id="fileInput"
              style="display: none"
              type="file"
              @change="onFileSelected"
              ref="fileInput"
              aria-label="เลือกไฟล์รูปภาพ"
            />
            <v-btn
              v-show="selectedFiles.length < 3"
              @click="$refs.fileInput.click()"
              outlined
              color="primary"
            >
              <v-icon left>mdi-plus</v-icon> เพิ่มรูป
            </v-btn>
          </div>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            v-if="showDeleteButton"
            class="red darken-2 mr-3"
            dark
            depressed
            @click="onDelete"
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::announcement:delete')"
          >
            ลบ
          </v-btn>
          <v-btn
            v-if="showSubmitButton"
            class="primary mr-3"
            depressed
            @click="onSubmit"
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::announcement:create')"
            >ตกลง
          </v-btn>
          <v-btn
            v-if="showSaveButton"
            class="primary mr-3"
            depressed
            @click="onSave"
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::announcement:update')"
            >บันทึก
          </v-btn>
          <v-btn v-if="showCancelButton" depressed @click="onReset"
            >ยกเลิก</v-btn
          >
          <v-btn
            v-if="showSendButton"
            class="primary"
            depressed
            @click="handleSendAnnouncement"
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::announcement:send')"
            >ส่งประกาศ
          </v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import { mapActions } from 'vuex'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DatePicker,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    announcement: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    announcementInit: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      selectedFiles: [],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isCreatedAnnouncement() {
      return this.$store.state.announcement.isCreatedAnnouncement
    },
    isAnnouncementDataChange() {
      const current = this.announcement?.expired_datetime
        ? moment(this.announcement.expired_datetime).valueOf()
        : null
      const initial = this.announcementInit?.expired_datetime
        ? moment(this.announcementInit.expired_datetime).valueOf()
        : null
      return current !== initial
    },
    showDeleteButton() {
      return (
        (!this.isAnnouncementDataChange && this.formAction === 'edit') ||
        (this.isCreatedAnnouncement && this.formAction === 'add')
      )
    },
    showSubmitButton() {
      return this.formAction === 'add' && !this.isCreatedAnnouncement
    },
    showSaveButton() {
      return this.formAction === 'edit' && this.isAnnouncementDataChange
    },
    showCancelButton() {
      return (
        (!this.isCreatedAnnouncement && this.formAction === 'add') ||
        (this.isAnnouncementDataChange && this.formAction === 'edit')
      )
    },
    showSendButton() {
      return (
        this.isCreatedAnnouncement ||
        (this.formAction === 'edit' &&
          !this.announcement.sent_datetime &&
          !this.isAnnouncementDataChange)
      )
    },
  },
  watch: {
    isAnnouncementDataChange(newVal) {
      this.$emit('isAnnouncementDataChange', newVal)
    },
  },
  methods: {
    ...mapActions({
      addAnnouncement: 'announcement/addAnnouncement',
      editAnnouncement: 'announcement/editAnnouncement',
      deleteAnnouncement: 'announcement/deleteAnnouncement',
    }),
    handleSendAnnouncement() {
      this.$emit('onClickSendAnnouncement')
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) =>
          reject(new Error(`Failed to read file: ${error.message}`))
      })
    },
    handleDeleteFile(uuid) {
      this.selectedFiles = this.selectedFiles.filter(
        (file) => file.uuid !== uuid
      )
    },
    async onFileSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      // Validate file type
      if (!file.type.startsWith('image/')) {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 3000,
          message: 'เฉพาะไฟล์รูปภาพเท่านั้น',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
        return
      }

      // Validate file size (e.g., max 1MB)
      if (file.size > 1 * 1024 * 1024) {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 3000,
          message: 'ขนาดไฟล์เกิน 1MB',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
        return
      }

      try {
        const base64 = await this.toBase64(file)

        this.selectedFiles.push({
          uuid: uuidv4(),
          image_base64: base64,
          image_extension: `.${file.name.split('.').pop()}`,
        })
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message:
            error?.response?.data?.message || 'Error converting file to Base64',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }

      event.target.value = ''
    },
    checkEmpty(value, field) {
      if (value) {
        this.announcement[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบประกาศ',
        value: this.announcement.title,
        item: this.announcement,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(announcement) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteAnnouncement({
        company_uuid,
        announcement_uuid: announcement.announcement_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', {
            formAction: this.formAction,
            action: 'deleting',
          })
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.commit('SET_LOADING', true)

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: {
              title: this.announcement.title,
              message: this.announcement.message
                .split('\n') // Split text into lines
                .map((line) => line.trimEnd()) // Trim right spaces for each line
                .join('\n'), // Join lines back,
              expired_datetime: this.announcement.expired_datetime
                ? moment(
                    this.announcement.expired_datetime,
                    'DD/MM/YYYY HH:mm'
                  ).format()
                : null,
              announcement_image: this.selectedFiles.length
                ? this.selectedFiles.map((file, index) => ({
                    ...file,
                    image_base64: file.image_base64.split(',')[1],
                    display_order: index + 1,
                  }))
                : null,
            },
          }

          const announcement = await this.addAnnouncement(payload)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$store.commit('announcement/SET_IS_CREATED_ANNOUNCEMENT', true)
          this.$emit('formActionCompleted', {
            formAction: this.formAction,
            action: 'submitting',
            data: announcement,
          })
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.commit('SET_LOADING', false)
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.commit('SET_LOADING', true)

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            announcement_uuid: this.announcement.announcement_uuid,
            body: {
              expired_datetime: this.announcement.expired_datetime
                ? moment(
                    this.announcement.expired_datetime,
                    'DD/MM/YYYY HH:mm'
                  ).format()
                : null,
            },
          }

          await this.editAnnouncement(payload)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', {
            formAction: this.formAction,
            action: 'saving',
          })
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.commit('SET_LOADING', false)
        }
      }
    },
    onClose() {
      if (this.isAnnouncementDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$store.commit('announcement/SET_IS_CREATED_ANNOUNCEMENT', false)
        this.$emit('formActionCompleted', {
          formAction: this.formAction,
          action: 'closeting',
        })
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$store.commit('announcement/SET_IS_CREATED_ANNOUNCEMENT', false)
      this.$emit('formActionCompleted', {
        formAction: this.formAction,
        action: 'confirm',
      })
    },
    onReset() {
      this.$refs.form.resetValidation()
      this.$store.commit('announcement/SET_IS_CREATED_ANNOUNCEMENT', false)
      this.selectedFiles = []

      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
